import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/lilita-one/400.css";
import "@fontsource/baloo-2/500.css";
import "@fontsource/baloo-2/700.css";
import "./styles.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Elemento #root não encontrado");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
